import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-subtitle-2"},[_vm._v(_vm._s(this.title))]),_c(VDivider,{staticClass:"marg-title"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }